import { render, staticRenderFns } from "./advisory.vue?vue&type=template&id=9ddf43a2&scoped=true"
import script from "./advisory.vue?vue&type=script&lang=js"
export * from "./advisory.vue?vue&type=script&lang=js"
import style0 from "./advisory.vue?vue&type=style&index=0&id=9ddf43a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ddf43a2",
  null
  
)

export default component.exports